import { IonContent, IonPage } from "@ionic/react";
import React from "react";
import { ChallengeList } from "../components/challenges/ChallengeList";
import { HelpoHeader } from "../components/shared/HelpoHeader";

export const Home: React.FC = () => (
  <IonPage>
    <HelpoHeader title="Challenges" hideBackButton />
    <IonContent className="ion-no-padding">
      <ChallengeList />
    </IonContent>
  </IonPage>
);